const STORAGE_KEY = "programBuilder.quickstart.visibility";

export type QuickstartVisibilityState = {
  open: boolean; // whether popover is expanded
  minimized: boolean; // whether only the pill is visible
};

const defaultState: QuickstartVisibilityState = { open: true, minimized: false };

const isQuickstartVisibilityState = (v: unknown): v is QuickstartVisibilityState => {
  if (typeof v !== "object" || v === null) return false;
  const obj = v as { open?: unknown; minimized?: unknown };
  return typeof obj.open === "boolean" && typeof obj.minimized === "boolean";
};

export function loadQuickstartVisibility(): QuickstartVisibilityState {
  try {
    if (typeof window === "undefined") return defaultState;
    const ls = window.localStorage;
    const raw = ls.getItem(STORAGE_KEY);
    if (!raw) return defaultState;
    const parsed: unknown = JSON.parse(raw);
    if (isQuickstartVisibilityState(parsed)) {
      return parsed;
    }
  } catch (/* istanbul ignore next */ e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
  return defaultState;
}

export function saveQuickstartVisibility(state: QuickstartVisibilityState): void {
  try {
    if (typeof window === "undefined") return;
    const ls = window.localStorage;
    ls.setItem(STORAGE_KEY, JSON.stringify(state));
  } catch (/* istanbul ignore next */ e) {
    // eslint-disable-next-line no-console
    console.warn(e);
  }
}
